import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export const STATUSES = [
  { key: "received", label: "Received", color: "#06B6D4" },
  { key: "diagnosing", label: "Diagnosing", color: "#F59E0B" },
  { key: "awaiting_parts", label: "Awaiting parts", color: "#D97706" },
  { key: "repairing", label: "Repairing", color: "#FF5500" },
  { key: "ready", label: "Ready", color: "#10B981" },
  { key: "completed", label: "Completed", color: "#94A3B8" },
  { key: "cancelled", label: "Cancelled", color: "#EF4444" },
];

export const statusOf = (k) => STATUSES.find((s) => s.key === k) || STATUSES[0];

export const handoffLabel = (h) => ({ collection: "Pick up", post: "Posting" }[h] || (h ? "Drop-off" : "To be arranged"));

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "";
